var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionButton',{attrs:{"onBtnClick":_vm.handleBtnClick}},[(!_vm.isPlaying)?[_c('img',{attrs:{"src":"assets/img/b3-quiz-button-play.png"}})]:[_c('img',{attrs:{"src":"assets/img/b3-quiz-button-pause.png"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }